namespace TabAurous.Finance {
    export namespace PDCReceivableService {
        export const baseUrl = 'Finance/PDCReceivable';

        export declare function Create(request: Serenity.SaveRequest<PDCReceivableRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PDCReceivableRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PDCReceivableRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PDCReceivableRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function VoucherList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PDCReceivableRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Finance/PDCReceivable/Create",
            Update = "Finance/PDCReceivable/Update",
            Delete = "Finance/PDCReceivable/Delete",
            Retrieve = "Finance/PDCReceivable/Retrieve",
            List = "Finance/PDCReceivable/List",
            VoucherList = "Finance/PDCReceivable/VoucherList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'VoucherList'
        ].forEach(x => {
            (<any>PDCReceivableService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
